import { Button, Col, Form, Row, Spinner } from "react-bootstrap";

const VehicleCategoryForm = ({
  form,
  validationErrors,
  submitting,
  isEditMode,
  onSubmit,
  onFieldChange,
  onBack,
}) => {
  return (
    <Form onSubmit={onSubmit}>
      <Row>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Name</Form.Label>
            <Form.Control
              type="text"
              value={form.name}
              onChange={(e) => onFieldChange("name", e.target.value)}
              placeholder="Enter category name"
              isInvalid={!!validationErrors.name}
            />
            <Form.Control.Feedback type="invalid">
              {validationErrors.name}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>

        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>No. of Seats</Form.Label>
            <Form.Control
              type="number"
              min="1"
              value={form.noOfSeats}
              onChange={(e) => onFieldChange("noOfSeats", e.target.value)}
              placeholder="Enter seats count"
              isInvalid={!!validationErrors.noOfSeats}
            />
            <Form.Control.Feedback type="invalid">
              {validationErrors.noOfSeats}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>

        <Col md={12}>
          <Form.Group className="mb-3">
            <Form.Label>Description (Optional)</Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              value={form.description}
              onChange={(e) => onFieldChange("description", e.target.value)}
              placeholder="Enter description"
            />
          </Form.Group>
        </Col>
      </Row>

      <div className="d-flex gap-2 mt-2">
        <Button type="submit" disabled={submitting}>
          {submitting ? (
            <>
              <Spinner as="span" animation="border" size="sm" className="me-2" />
              {isEditMode ? "Saving..." : "Creating..."}
            </>
          ) : (
            isEditMode ? "Save Changes" : "Create Category"
          )}
        </Button>
        <Button type="button" variant="light" disabled={submitting} onClick={onBack}>
          Back
        </Button>
      </div>
    </Form>
  );
};

export default VehicleCategoryForm;
